import React, { Component } from 'react';
import { translate } from 'react-i18next';
import SplitButton from '../../../../common/components/UI/SplitButton/V2/SplitButton';
import { updateSidePanelData, updateShowSidePanel } from '../actions';
import { connect } from 'react-redux';
import { exists } from '../../../../common/utilities/utilitiesFunctions';

class WorkplanActionOptions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selectedIndex: 0
        }
    }

    componentDidUpdate() {
        const { options } = this.props;
        const { selectedIndex } = this.state;

        let selectedIndexAux = 0;
        const loadingActionIndex = options.findIndex(x => x.isShowProgress);
        if (loadingActionIndex !== -1) {
            selectedIndexAux = loadingActionIndex;
        }
        else if (options[0].disabled) {
            for (const [index, option] of options.entries()) {
                if (option.disabled && exists(options[index + 1])) {
                    selectedIndexAux = index + 1;
                }
            }
        }

        if (selectedIndex !== selectedIndexAux) {
            this.setState({ selectedIndex: selectedIndexAux });
        }
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    getAction = (option) => {
        return (option.edit ? 'Edit' : '') + option.value;
    }

    handleWorkplanActionRequest = () => {
        const { updateSidePanelData, selectedWorkPlan, options, t } = this.props;
        const { selectedIndex } = this.state;

        let action = this.getAction(options[selectedIndex]);
        let startDate;
        let endDate;

        if (action === 'RolloutWorkplan' || action === 'EditRolloutWorkplan' || action === 'PauseWorkplan') {
            startDate = options[selectedIndex].edit ? selectedWorkPlan.startDate : undefined
            endDate = options[selectedIndex].edit ? selectedWorkPlan.endDate : undefined
        } else if (action === 'EditPauseWorkplan') {
            startDate = selectedWorkPlan.states.find(state => state.label === 'Paused').effectiveDate;
            endDate = selectedWorkPlan.states.find(state => state.label === 'Paused').endDate;
        } else {
            startDate = undefined;
            endDate = undefined;
        }

        updateSidePanelData({
            formTitle: t('workPlan.' + action),
            action: action,
            selectedStartDate: startDate,
            selectedEndDate: endDate
        });
    }

    handleWorkplanActionType = (event, index) => {
        const { updateSidePanelData, selectedWorkPlan, options, t } = this.props;
        let action = this.getAction(options[index]);
        let startDate;
        let endDate;

        if (action === 'RolloutWorkplan' || action === 'EditRolloutWorkplan' || action === 'PauseWorkplan') {
            startDate = options[index].edit ? selectedWorkPlan.startDate : undefined
            endDate = options[index].edit ? selectedWorkPlan.endDate : undefined
        } else if (action === 'EditPauseWorkplan') {
            startDate = selectedWorkPlan.states.find(state => state.label === 'Paused').effectiveDate;
            endDate = selectedWorkPlan.states.find(state => state.label === 'Paused').endDate;
        } else {
            startDate = undefined;
            endDate = undefined;
        }

        updateSidePanelData({
            formTitle: t('workPlan.' + action),
            action: action,
            selectedStartDate: startDate,
            selectedEndDate: endDate
        });

        this.setState({
            selectedIndex: index,
            open: false
        });
    }

    handleToggle = () => {
        const { open } = this.state;

        this.setState({ open: !open });
    }

    render() {
        const { options, disabled, classes } = this.props;
        const { selectedIndex, open } = this.state;
        
        return (
            <SplitButton
                options={options}
                open={open}
                selectedIndex={selectedIndex}
                size='medium'
                color='primary'
                handleClick={this.handleWorkplanActionRequest}
                handleMenuItemClick={this.handleWorkplanActionType}
                handleToggle={this.handleToggle}
                handleClose={this.handleClose}
                className={classes.WorkplanButtonAction}
                placeholder={'Workplan Action'}
                disabled={disabled}
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedWorkPlan: state.selectedWorkPlan,
        sidePanelData: state.sidePanelData
    }
}

const mapDispatchToProps = {
    updateSidePanelData,
    updateShowSidePanel,
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(WorkplanActionOptions));